import {EDjangoAppsEndpoints} from '../enums/EDjangoAppsEndpoints';
import {type IAugmentedBackendResponse} from '../models/IAugmentedBackendResponse';
import {type ISortingMeta} from '../models/ISortingMeta';
import {type TPandasTable} from '../models/TPandasTable';
import ApiService from './apiService';
import {type IUsageTrackingInfo} from '../models/usage-tracking/IUsageTracking';

export class SvUsageTrackingServices extends ApiService {
  static async getUsageOverView(params: {
    page: number;
    sorting: ISortingMeta;
    search?: string;
  }) {
    return await super.get<IAugmentedBackendResponse<TPandasTable>>(EDjangoAppsEndpoints.usageTracking, 'admin/usage', {
      page: params.page,
      sortCol: params.sorting.sortCol,
      ascending: params.sorting.ascending,
      searchText: params.search ?? '',
    });
  }

  static async createUsageTrackingRecord(params: IUsageTrackingInfo) {
    return await super.get<{ success: boolean }>(EDjangoAppsEndpoints.usageTracking, '/', {
      app: params.app,
      sourceType: params.sourceType,
      sourceIdentifier: params.sourceIdentifier,
    });
  }

  static async getAppOverView(params: {
    appName: string;
    page: number;
    sorting: ISortingMeta;
    search?: string;
  }) {
    return await super.get<IAugmentedBackendResponse<TPandasTable>>(EDjangoAppsEndpoints.usageTracking, 'admin/app-stats', {
      appName: params.appName,
      page: params.page,
      sortCol: params.sorting.sortCol,
      ascending: params.sorting.ascending,
      searchText: params.search ?? '',
    });
  }

  static async deleteUsageTrackingAppWide(app: string) {
    return await super.delete<{
      success: boolean,
      message: string
    }>(EDjangoAppsEndpoints.usageTracking, `admin/delete/all-app?app=${app}`);
  }

  static async deleteUsageTrackingNonAppWide(params: IUsageTrackingInfo) {
    return await super.delete<{
      success: boolean,
      message: string
    }>(EDjangoAppsEndpoints.usageTracking, `admin/delete/single-app?app=${params.app}&sourceType=${params.sourceType}&sourceIdentifier=${params.sourceIdentifier}`);
  }
}